import { Injectable } from '@angular/core';
import {
    Router,
    CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
} from '@angular/router';

import { CookieService } from 'ngx-cookie-service';

@Injectable({ providedIn: 'root' })
export class LoginGuard implements CanActivate {
    constructor(private cs: CookieService, private router: Router) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const token = localStorage.getItem('__bt');
        const subExpired = localStorage.getItem('subExpired');

        if (token && !subExpired) {
            this.router.navigate(['dashboard']);
            return false;
        }
        return true;
    }
}
